import { $ } from "hanako-ts/dist-legacy/Framework";
import { Field } from "./Field";
export class Multiselect extends Field {
    constructor(field) {
        super(field);
        this.values = [];
        this.formFieldData = this.field.find('.form-field-data');
        this.formControl = this.field.find('.form-control');
        this.formSelection = this.field.find('.form-selection');
        this.dropdownItems = this.field.find('.dropdown-item');
        this.badge = this.field.find('.badge');
        $('body').on('click', (event) => {
            if ($(event.target).parents('.form-field-multiselect').length == 0)
                this.unfocus();
        });
        this.formControl.on('click', (event, item) => {
            this.focus();
        });
        this.formSelection.on('click', (event, item) => {
            this.focus();
        });
        this.dropdownItems.on('click', (event, item) => {
            event.preventDefault();
            if (item.hasClass('active')) {
                this.removeElement(item.data('value'));
            }
            else {
                this.addElement(item.data('value'));
            }
        });
    }
    loadData() {
        this.formSelection.empty();
        this.dropdownItems.removeClass('active');
        const fieldValue = this.formFieldData.val();
        this.values = fieldValue === '' ? [] : this.formFieldData.val().split(',');
        this.values.forEach((value) => {
            this.addElement(value, true);
        });
    }
    addElement(value, ignoreData = false) {
        if (!ignoreData) {
            this.values.push(value);
            this.update();
        }
        const dropdownItems = this.dropdownItems.search('[data-value="' + value + '"]').addClass('active');
        const newBadge = this.badge.clone();
        newBadge.removeClass('d-none');
        newBadge.find('span').text(dropdownItems.text());
        newBadge.data('value', value);
        newBadge.find('a').on('click', (event, button) => {
            event.preventDefault();
            this.removeElement(button.parent().data('value'));
        });
        this.formSelection.append(newBadge);
    }
    removeElement(value) {
        const valueIndex = this.values.indexOf(value);
        this.values.splice(valueIndex, 1);
        this.update();
        this.formSelection.find('.badge[data-value="' + value + '"]').remove();
        this.dropdownItems.search('[data-value="' + value + '"]').removeClass('active');
    }
    update() {
        this.formFieldData.val(this.values.join(',')).trigger('change');
    }
    focus() {
        this.formControl.addClass('focus');
    }
    unfocus() {
        this.formControl.removeClass('focus');
    }
    count() {
        return this.values.length;
    }
    has(value) {
        return this.values.indexOf(value) > -1;
    }
}
